import { useState } from 'react';

const AVATAR_COLORS: ReadonlyArray<readonly [string, string]> = [
  ['#FCE4D6', '#9E4221'],
  ['#DCE9FD', '#1B4F8E'],
  ['#E0EFD9', '#27632A'],
  ['#F6DDE6', '#8E2A55'],
  ['#EEE2F8', '#5A3B8C'],
  ['#FFEAC4', '#7A4A0A'],
];

export interface AvatarProps {
  name?: string;
  size?: number;
  src?: string | null;
}

export function Avatar({ name, size = 24, src }: AvatarProps) {
  const [errored, setErrored] = useState(false);

  const showImage = !!src && !errored;

  const initials = (name ?? '?')
    .split(' ')
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  const idx = (name ?? '').charCodeAt(0) % AVATAR_COLORS.length;
  const [bg, fg] = AVATAR_COLORS[Number.isNaN(idx) ? 0 : idx];

  if (showImage) {
    return (
      <img
        src={src as string}
        alt={name}
        title={name}
        onError={() => setErrored(true)}
        style={{
          width: size,
          height: size,
          borderRadius: 999,
          objectFit: 'cover',
          border: '1.5px solid var(--surface-raised)',
          flex: '0 0 auto',
          display: 'inline-block',
        }}
      />
    );
  }

  return (
    <div
      title={name}
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        background: bg,
        color: fg,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        fontSize: Math.max(9, size * 0.4),
        letterSpacing: '-0.01em',
        border: '1.5px solid var(--surface-raised)',
        flex: '0 0 auto',
      }}
    >
      {initials}
    </div>
  );
}
